import { List, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { NavItem } from '../styles/navItem';
import { IconImage } from '../iconImage';
import {
    FORM_DRIVER_REGISTER,
    DRIVER_ROUTE,
    RIDER_REPORT,
} from '../../../routes/paths';
import driver_ic from '../../../assets/images/drawer_icons/driver.svg';
import order_ic from '../../../assets/images/dashboard/order_ic.svg';
import customer_ic from '../../../assets/images/dashboard/ic_user.svg';


const HrNavbar = () => {
    const { t } = useTranslation("global");

    return (
        <List disablePadding sx={{ p: 1, paddingBottom: 10 }}>

            {/* <Typography sx={{ mb: 2, mt: 2, pl: 1, fontWeight: 'bold', color: "#637381" }}>{t("navbar.REPORT")}</Typography>
            <NavItem title={t("navbar.Rider Report")} path={RIDER_REPORT} icon={<IconImage imageUrl={driver_ic} />} /> */}


            <Typography sx={{ mb: 2, mt: 2, pl: 1, fontWeight: 'bold', color: "#637381" }}>{t("navbar.MANAGEMENT")}</Typography>
            {/* <NestedListItem nestedValue={t('navbar.Driver')} iconSrc={driver_ic} listItems={[
                <NavItem title={t("navbar.All Driver")} path={DRIVER_ROUTE} icon={<IconNestedListItemImage imageUrl={nested_list_item_ic} />} />,
                <NavItem title={t("navbar.Driver Form Register")} path={FORM_DRIVER_REGISTER} icon={<IconNestedListItemImage imageUrl={nested_list_item_ic} />} />,
            ]} /> */}
            <NavItem title={t("navbar.All Driver")} path={DRIVER_ROUTE} icon={<IconImage imageUrl={driver_ic} />} />
            <NavItem title={t("navbar.Driver Form Register")} path={FORM_DRIVER_REGISTER} icon={<IconImage imageUrl={customer_ic} />} />

        </List>
    )
}

export default HrNavbar